import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule, Form, Text,
} from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

import { sortOptions } from '@functions/paginationRule'

import usePaginationRuleSort from '@hooks/usePaginationRuleSort'

import type { PaginationRuleModel } from '@models/types'

import SortListItem from './SortListItem'

interface PaginationRuleSortProps {
  paginationRule: PaginationRuleModel,
  paginationRuleFormPayload: UseFormPayload,
}

const PaginationRuleSort = (props: PaginationRuleSortProps) => {
  const { paginationRule, paginationRuleFormPayload } = props

  const {
    entityState: {
      sort_items_by,
    },
    errors,
  } = paginationRuleFormPayload

  const {
    callbacks: {
      setParams,
      setSortOrderState,
      toggleSortItem,
    },
    descEnabled,
    disabled,
    sortItemsType,
    sortOrder,
  } = usePaginationRuleSort({ paginationRule, paginationRuleFormPayload })

  const hasSortItems = !!sort_items_by.length

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title="Pagination Sort Rules"
    >
      <Form>
        <Form.Row
          boxProps={{
            borderBottom: '1px solid',
            borderColor: 'lineColor',
            gridAutoFlow: [0, 'column'],
            padding: 'large',
          }}
        >
          <Form.Field>
            <select value={sortItemsType} onChange={e => setParams!(e.target.value)}>
              {sortOptions.map(sortOption => (
                <option key={sortOption.key} value={sortOption.key}>{sortOption.label}</option>
              ))}
            </select>
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field marginTop={['large', 0]}>
            <select value={sortOrder} onChange={e => setSortOrderState(e.target.value)}>
              {descEnabled && <option value="desc">Descending (Biggest to Smallest)</option>}
              {sortItemsType !== 'promo' && <option value="asc">Ascending (Smallest to Biggest)</option>}
            </select>
          </Form.Field>

          <Button
            buttonStyle="secondaryEdit"
            disabled={disabled}
            height="37px"
            icon={<FontAwesomeIcon icon={faPlus} />}
            marginTop={['large', 0]}
            onClick={() => toggleSortItem(`${sortItemsType}.${sortOrder}`)}
            size="medium"
          >
            Add To Sort
          </Button>
        </Form.Row>

        <Box flexDirection="column">
          <Form.Field
            errorMessage={errors.sort_items_by}
            label="Applied Sorting"
            labelProps={{
              marginBottom: 0, paddingTop: 'large', paddingLeft: 'large', paddingBottom: hasSortItems ? 0 : 'large',
            }}
          >
            {sort_items_by.map((sortItem: string) => (
              <SortListItem
                callbacks={{ toggleSortItem }}
                key={sortItem}
                sortItem={sortItem}
              />
            ))}
          </Form.Field>
        </Box>
      </Form>
    </DashboardModule>
  )
}

export default PaginationRuleSort
